module.exports = __webpack_public_path__ + "img/model_70_ug.b94543ba.png";